import React, { createContext, useState } from 'react';

//principal: "http://localhost:8000/api/"
//principal: "https://backendgbl.continente.co/api/"
export const urlrestapi = {
  //principal: "http://localhost:8000/api/"
  principal: "https://backendgbl.continente.co/api/"
  };
export const Datarestapi = React.createContext(urlrestapi.principal);